/**
 * User: hella
 * Date: 4/9/14
 * Time: 2:18 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

const $ = require('dibs-jquery-shim');
const SV = require('server-vars');
const React = require('react');
const ReactDOM = require('react-dom');
const User = require('./models/User');
const nav = require('./core/nav/nav.es');
const navDfp = require('./core/nav/dfp');
const tooltips = require('./modules/commonjs/dibsTooltips');
const tapEvents = require('./utils/commonjs/tapEvents');
const deepLink = require('./core/deepLink');
const log = require('bunsen/helpers/log');
const scriptLoader = require('bunsen/helpers/scriptLoader');
const browserCheck = require('bunsen/helpers/browserCheck');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const windowCheck = require('bunsen/helpers/windowCheck');
const userTracking = require('./core/user.tracking');
const pageViewTracking = require('./tracking/gas.dibs.pageview');
const ContextProvider = require('./reactHelpers/ContextProvider');
const LogoTradeIcon = require('dibs-vg/dist/react/logo-trade');
const { addLoginHandlers } = require('dibs-buyer-layout/src/entries/index');
// Component helpers:
const notificationHelper = require('./notifications/notificationHelper');
const currencySelectHelper = require('../components/CurrencySelect/currencySelect-helper');

require('../thirdParty/pointerevents');
require('bunsen/libraries/plugins/jquery.cookie.js');

/**
 * @returns {string} classes
 */
function getBodyClass() {
    const classes = [];
    if (!mobileCheck.isTouchDevice()) {
        classes.push('no-touch');
    } else {
        classes.push('has-touch');
    }
    if (browserCheck.ie()) {
        classes.push('is-ie');
    }
    if (mobileCheck.Android() && !browserCheck.chrome()) {
        //eslint-disable-line new-cap
        classes.push('is-android');
    }
    return classes.join(' ');
}

function setBodyClass() {
    const classes = getBodyClass();
    if (classes) {
        $('body').addClass(classes);
    }
}

function setTradeHeader() {
    User.load().done(() => {
        const bodyEl = document.querySelector('body');
        const tradeClass = 'is-trade';
        const hasTradeClass = bodyEl.className.includes(tradeClass);

        if (hasTradeClass) {
            return;
        }

        if (User.getCurrentUser().isVerifiedTradeBuyer()) {
            bodyEl.className += ` ${tradeClass}`;

            const logoEls = [
                document.querySelector('.logo-header .logo-link'),
                document.querySelector('.global-nav-logo .logo-link'),
            ];

            logoEls.forEach(logoEl => {
                if (logoEl) {
                    ReactDOM.render(React.createElement(LogoTradeIcon), logoEl);
                }
            });
        }
    });
}

/**
 * =====================================================================================================================
 * GLOBAL jQuery ready
 * put global on ready handlers here
 * =====================================================================================================================
 */
$(function() {
    deepLink.forwardFromEmail();

    setBodyClass();

    if (User.loggedIn()) {
        setTradeHeader();
    } else {
        $.subscribe('login:change', setTradeHeader);
    }

    $.subscribe('user:loaded', function(e, user) {
        // configure remote logger to log user
        try {
            log.configureLogUser.apply(log, [
                user.id,
                user.getFullName(),
                user.getUserProfile().email,
            ]);
        } catch (err) {
            log.remote.warn(err);
        }
    });

    User.updateLoginState();
    userTracking.init();
    pageViewTracking.init();
    addLoginHandlers(() => {
        User.updateLoginState();
    });
    /*
    This server var is only set in checkout_base.twig, PDP Print, and standalone /registration/ page, because doesn't
        use the nav bar at all, but .getContext() gets called from every entry file
        since base.js gets bundled into foot.js
    */
    const initializeNavBar = !SV.get('disableNavBar');
    const select = windowCheck.document.querySelectorAll('.js-currency-select')[0];

    ContextProvider
        .getContext()
        .then(function (context) {
            if (initializeNavBar) {
                nav.init(notificationHelper(context));
            }

            currencySelectHelper.init({context, select});
        });

    tapEvents.init();
    navDfp.init();
    tooltips.initTooltips();

    $.subscribe('modal:show backbone:viewRendered page:updated', tooltips.initTooltips);
    $.subscribe('modal:show modal:close', tooltips.closeAllTooltips);
    // similar functionality in nav.js for search box, should be consolidated at some point
    // search for 'body *'
    $('body').on('click touchstart', function(e) {
        const $target = $(e.target);
        if (
            !$target.hasClass('dibstooltip-trigger') &&
            !$target.hasClass('dibstooltip') &&
            !$target.parents('.dibstooltip').length
        ) {
            tooltips.closeAllTooltips();
        }
    });

    User.handleEmailToken();
});

/**
 * =====================================================================================================================
 * GLOBAL WINDOW ONLOAD EVENT
 * Put global window onload handlers here
 * =====================================================================================================================
 */
$(window).load(function() {
    const thirdPartyFootImg = SV.get('thirdPartySrcs.foot.img');
    const thirdPartyFootScript = SV.get('thirdPartySrcs.foot.script');

    // hide address bar on iOS
    if (mobileCheck.iOS()) {
        setTimeout(function() {
            if ($(window).scrollTop() === 0) {
                // but only if user hasn't already scrolled away from the top
                window.scrollTo(0, 1);
            }
        }, 0);
    }
    if (thirdPartyFootImg) {
        scriptLoader.pixel.load(thirdPartyFootImg);
    }
    if (thirdPartyFootScript) {
        scriptLoader.script.load(thirdPartyFootScript, false, 'body');
    }
});



// WEBPACK FOOTER //
// ./assets/js/global/base.es.js